import React from 'react';
import clsx from 'clsx';
import { GenericModal } from '@components/common/modals';
import Button from '@components/common/Button';
import styles from './ConfirmActionModal.module.css';

interface DependencyInfo {
  active_assessments?: number;
  meetings_host?: number;
  contracts_managed?: number;
  contracts_owned?: number;
  [key: string]: number | undefined;
}

interface ConfirmActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  dependencies?: DependencyInfo;
  isSubmitting: boolean;
  actionType: 'delete' | 'deactivate' | 'warning';
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  dependencies,
  isSubmitting,
  actionType
}) => {
  const hasDependencies = dependencies && Object.values(dependencies).some((v) => v && v > 0);
  const isBlocking = actionType === 'delete' && hasDependencies;

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          {!isBlocking && (
            <Button variant={actionType === 'delete' ? 'danger' : 'primary'} onClick={onConfirm} loading={isSubmitting}>
              Confirm
            </Button>
          )}
        </>
      }
    >
      <div className="confirmation-content">
        <p>{message}</p>

        {hasDependencies && (
          <div className={clsx('dependency-warning', isBlocking ? 'blocking' : 'warning')}>
            <h4>{isBlocking ? 'Cannot Delete: Dependencies Found' : 'Warning: Active Items'}</h4>
            <ul>
              {dependencies.active_assessments ? <li>{dependencies.active_assessments} Active Assessments</li> : null}
              {dependencies.meetings_host ? <li>{dependencies.meetings_host} Scheduled Meetings</li> : null}
              {dependencies.contracts_managed ? <li>{dependencies.contracts_managed} Managed Contracts</li> : null}
            </ul>
            {isBlocking && <p className={styles.helpText}>Please deactivate the user or reassign items instead.</p>}
          </div>
        )}
      </div>
    </GenericModal>
  );
};

export default ConfirmActionModal;
